import { createPortal } from "react-dom";
import { MoreHorizontal, Pencil, Trash2 } from "lucide-react";
import type { Project } from "../../api/types.js";
import { projectDisplayName } from "../shared/constants.js";
import type { FloatingPosition } from "./useFloatingMenu.js";
import { SESSION_MENU_WIDTH } from "./useFloatingMenu.js";

export function ProjectMenu({
  project,
  menuOpen,
  menuPosition,
  openProjectMenu,
  closeProjectMenu,
  closeSessionMenu,
  onRenameProject,
  onDeleteProject
}: {
  project: Project;
  menuOpen: boolean;
  menuPosition: FloatingPosition | null;
  openProjectMenu: (projectId: string, rect: DOMRect, width: number, height: number) => void;
  closeProjectMenu: () => void;
  closeSessionMenu: () => void;
  onRenameProject: (project: Project) => void;
  onDeleteProject: (project: Project) => void;
}) {
  return (
    <>
      <button
        className="history-menu-button project-menu-button"
        type="button"
        aria-haspopup="menu"
        aria-expanded={menuOpen}
        aria-label={`${projectDisplayName(project)} 更多操作`}
        onClick={(event) => {
          event.stopPropagation();
          if (menuOpen) {
            closeProjectMenu();
            return;
          }
          closeSessionMenu();
          openProjectMenu(project.id, event.currentTarget.getBoundingClientRect(), SESSION_MENU_WIDTH, 92);
        }}
      >
        <MoreHorizontal size={17} />
      </button>
      {menuOpen && menuPosition && createPortal(
        <div
          className="history-menu floating-project-menu"
          role="menu"
          data-session-menu-layer
          style={{ top: menuPosition.top, left: menuPosition.left }}
        >
          <button type="button" role="menuitem" onClick={() => { closeProjectMenu(); onRenameProject(project); }}>
            <Pencil size={15} />
            <span>重命名项目</span>
          </button>
          <button className="danger" type="button" role="menuitem" onClick={() => { closeProjectMenu(); onDeleteProject(project); }}>
            <Trash2 size={15} />
            <span>删除项目</span>
          </button>
        </div>,
        document.body
      )}
    </>
  );
}
